<template>
<Pagebody style="margin:0 auto;float:none;" :loading='false'>
    <div style='height:100px;'></div>
    <h1 class='transfer_title'>跳转中，请稍后... ...</h1>
    <div style='height:250px;'></div>
    <div style="display:none;" v-html="dom">
    </div>
</Pagebody>
</template>
<script>
import wh from '@/assets/js/wh.js'
    export default {
        name: 'ChinaPay',
        data: () => ({
            dom: ''
        }),
        mounted () {
            this.dom = localStorage.getItem('payDom')
            this.$nextTick(_=>{
                localStorage.setItem('payDom','')
                document.getElementById('submit').submit()
            })
            
        }
    }
</script>
<style scoped>
    .transfer_title{
        line-height: 50px;
        font-weight: normal;
        text-align: center;
        font-size: 18px;
        color: rgb(4, 27, 58);
        margin: 0;
        padding: 0;
        padding-bottom: 30px;
        padding-top: 170px;
        background: url(../assets/image/tiaozhuan.jpg) no-repeat center top;
    }
</style>